module.exports = __webpack_public_path__ + "static/media/trophy-silver.3a19ef56.svg";